// This file is generated by the Webpack next-flight-loader.
import { registerClientReference } from "react-server-dom-webpack/server";
export const IncidentHeaderSkeleton = registerClientReference(
function() { throw new Error("Attempted to call IncidentHeaderSkeleton() from the server but IncidentHeaderSkeleton is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
"/app/app/(keep)/incidents/[id]/incident-header-skeleton.tsx",
"IncidentHeaderSkeleton",
);